import {AaSequenceSpecifier} from 'analyses/aa-sequence-alignment/util/AaSequenceAlignmentConstants';
import {AaSequenceAlignment} from 'constants/AlignmentConstants';
import {AaSequenceServerResponse} from 'molbio/aa-sequences/util/AaSequenceConstants';
import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';
import {Optional} from 'util/Types';

const AaSequenceAlignmentDAO = {
  get(alignmentId: string): JQueryPromise<AaSequenceAlignment> {
    // @ts-expect-error: seems like we pass a legacy data format here
    return net.getJSON({
      url: `/1/api/aa-sequence-alignments/${alignmentId}`,
    });
  },

  create({
    aaSequenceName,
    folderId,
    templateAaSequenceIndex,
    aaSequenceSpecifiers,
  }: {
    aaSequenceName: string;
    folderId?: string;
    templateAaSequenceIndex: Optional<number>;
    aaSequenceSpecifiers: Array<AaSequenceSpecifier>;
  }): JQueryPromise<{protein: AaSequenceServerResponse; alignment: AaSequenceAlignment}> {
    return TaskRunner.runTask({
      contentType: 'application/json',
      url: '/1/api/aa-sequence-alignments',
      // Request keys are server-defined; see benchling/molbio/aa_sequences/api/alignments.py
      data: JSON.stringify({
        proteinName: aaSequenceName,
        folderId,
        proteinSpecifiers: aaSequenceSpecifiers,
        templateProteinIndex: templateAaSequenceIndex,
      }),
      dataType: 'json',
      type: 'POST',
    });
  },

  realignTemplate({
    alignmentId,
    aaSequenceSpecifiers,
  }: {
    alignmentId: string;
    aaSequenceSpecifiers: Array<AaSequenceSpecifier>;
  }): JQueryPromise<{protein: AaSequenceServerResponse; alignment: AaSequenceAlignment}> {
    return TaskRunner.runTask({
      contentType: 'application/json',
      url: `/1/api/aa-sequence-alignments/${alignmentId}/actions/realign-template`,
      // `proteinSpecifiers` is the server's request key; see benchling/molbio/aa_sequences/api/alignments.py
      data: JSON.stringify({proteinSpecifiers: aaSequenceSpecifiers}),
      dataType: 'json',
      type: 'POST',
    });
  },

  realignConsensus({
    alignmentId,
    aaSequenceSpecifiers,
  }: {
    alignmentId: string;
    aaSequenceSpecifiers: Array<AaSequenceSpecifier>;
  }): JQueryPromise<{protein: AaSequenceServerResponse; alignment: AaSequenceAlignment}> {
    return TaskRunner.runTask({
      contentType: 'application/json',
      url: `/1/api/aa-sequence-alignments/${alignmentId}/actions/realign-consensus`,
      // `proteinSpecifiers` is the server's request key; see benchling/molbio/aa_sequences/api/alignments.py
      data: JSON.stringify({proteinSpecifiers: aaSequenceSpecifiers}),
      dataType: 'json',
      type: 'POST',
    });
  },

  delete(alignmentId: string): JQueryPromise<void> {
    return net.delete_({
      url: `/1/api/aa-sequence-alignments/${alignmentId}`,
    });
  },

  rename(alignmentId: string, name: string): JQueryPromise<void> {
    return net.patchJSON({
      url: `/1/api/aa-sequence-alignments/${alignmentId}`,
      data: {name},
    });
  },
};

export default AaSequenceAlignmentDAO;
